module.exports = __webpack_public_path__ + "img/img151_11.aa446b22.png";